export default function formattedDate (lang, dateStr, format = 'month-day', formatOptions = {}, contextYearMonth = null) {
    // 날짜 문자열이 "yyyy-MM" 형식인지 확인
    const isYearMonth = /^\d{4}-\d{2}$/.test(dateStr)
    const isYearMonthDay = /^\d{4}-\d{2}-\d{2}$/.test(dateStr)
    const isDayOnly = /^\d{1,2}$/.test(dateStr) // 1~31 또는 01~31 허용

    if (!isYearMonth && !isYearMonthDay && !isDayOnly) {
        console.error(dateStr)
        throw new Error("Invalid date format. Expected 'yyyy-MM', 'yyyy-MM-dd' or 'dd'")
    }

    // Date.UTC로 생성 + 렌더도 UTC로 고정하여 사용자 로컬 타임존(특히 음 오프셋)에서 1일→전월 말일로 밀리는 버그를 차단한다
    let date
    if (isYearMonth) {
        const [y, m] = dateStr.split('-').map(Number)
        date = new Date(Date.UTC(y, m - 1, 1))
    } else if (isYearMonthDay) {
        const [y, m, d] = dateStr.split('-').map(Number)
        date = new Date(Date.UTC(y, m - 1, d))
    } else if (isDayOnly) {
        const yearMonth = contextYearMonth || new Date().toISOString().slice(0, 7)
        const [y, m] = yearMonth.split('-').map(Number)
        date = new Date(Date.UTC(y, m - 1, Number(dateStr)))
    }

    if (format === 'yyyy-MM') {
        return dateStr // 원본 유지
    }
    if (format === 'yyyy-MM-dd') {
        return dateStr // 원본 유지
    }

    // Intl.DateTimeFormat을 사용하는 경우
    const options = {}
    if (format === 'year-month') {
        options.year = formatOptions.year || 'numeric'
        options.month = formatOptions.month || 'short'
    } else if (format === 'year-month-day') {
        options.year = formatOptions.year || 'numeric'
        options.month = formatOptions.month || 'short'
        options.day = formatOptions.day || 'numeric'
    } else if (format === 'day') {
        options.day = formatOptions.day || 'numeric'
    } else {
        options.month = formatOptions.month || 'short'
        options.day = formatOptions.day || 'numeric'
    }

    return new Intl.DateTimeFormat(lang, { ...options, timeZone: 'UTC' }).format(date)
}
